import { useState } from "react"

import { processValidationErrors } from "../components/JiraTemplateModal/helpers"

import type { TestModalState } from "../components/TicketTestModal"
import type {
  RunTemplateTest,
  TemplateTestOptions
} from "./useTemplateTest.types"

// Sends a test ticket for a template and puts the vendor's errors back on the form
export const useTemplateTest = (options: TemplateTestOptions) => {
  const { form, t, setFormError, setServerErrors } = options
  const [testModalState, setTestModalState] = useState<TestModalState>(null)

  const confirmTest = async (
    runTest: RunTemplateTest,
    referenceValues: Record<string, unknown>
  ) => {
    setFormError(null)

    try {
      const result = await runTest()

      if (result.error) {
        const { formErrors, fieldErrors, hasFieldErrors } =
          processValidationErrors(result.error, t)

        setServerErrors(fieldErrors, referenceValues)
        Object.entries(fieldErrors).forEach(([name, error]) => {
          form.setFields([{ name, errors: [error] }])
        })
        if (hasFieldErrors) options.onFieldErrors?.()
        if (formErrors.length > 0) setFormError(formErrors.join("; "))
        setTestModalState(null)
      } else if (result.success && result.ticketKey && result.ticketUrl) {
        setTestModalState({
          ticketKey: result.ticketKey,
          ticketUrl: result.ticketUrl
        })
      } else if (result.success && options.validatesOnly) {
        setTestModalState("validated")
      } else {
        options.onEmptyResult?.()
      }
    } catch {
      setFormError(t("error.creationFailed"))
      setTestModalState(null)
    }
  }

  return { testModalState, setTestModalState, confirmTest }
}
